import { useEffect, useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { toast } from '../../../ui';

/** Small icon button that copies a value (UPI ID, amount, order number). */
const CopyButton = ({ value, label }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
      setCopied(true);
      toast.success('Copied');
    } catch {
      toast.error("Couldn't copy. Select the text and copy it instead.");
    }
  };

  return (
    <button
      type="button"
      className="co-copy"
      onClick={copy}
      aria-label={copied ? `${label}: copied` : label}
      title={label}
    >
      {copied ? <Check aria-hidden="true" /> : <Copy aria-hidden="true" />}
    </button>
  );
};

export default CopyButton;
